import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { ReactElement } from 'react';

import { Wrapper } from './styles';
import { CalmSleepLogoColor, CalmSleepLogoProps } from './types';

const CalmSleepLogo = ({
	className,
	height = 40,
	href,
	color = CalmSleepLogoColor.White,
	loader,
	preserveQueryParams = true,
	'aria-label': ariaLabel = 'Calm Sleep Logo - Link to Homepage',
	'data-testid': dataTestId = 'calm-sleep-logo',
}: CalmSleepLogoProps): ReactElement => {
	const queryParams = useSearchParams();
	const queryString = queryParams?.toString() ?? '';

	const isWhite = color === CalmSleepLogoColor.White;
	const actualWidth = 192;
	const actualHeight = isWhite ? 112 : 113;
	const aspectRatio = actualWidth / actualHeight;
	const width = height * aspectRatio;
	const src = isWhite ? '/_n/images/calm-sleep-logo.svg' : '/_n/images/calm-sleep-logo-gradient.svg';
	return (
		<Wrapper
			as={href ? 'a' : 'span'}
			className={className}
			$width={width}
			$height={height}
			{...(href && {
				'aria-label': ariaLabel,
				href: preserveQueryParams && queryString ? `${href}?${queryString}` : href,
			})}
		>
			<Image
				width={actualWidth}
				height={actualHeight}
				src={src}
				loader={loader}
				alt="Calm Sleep Logo"
				unoptimized
				data-testid={dataTestId}
				style={{ width: 'auto', height: `${height}px` }}
			/>
		</Wrapper>
	);
};
export default CalmSleepLogo;
